import { invalidate } from '@react-three/fiber';
import { useEffect } from 'react';

import { PivotControlsHandler } from 'app/modules/wallforming/components/scenes/tools/pivot-controls/PivotControlsHandler';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const PivotControlsContainer = () => {
    const arePivotControlsActive = usePlacementStore((state) => state.arePivotControlsActive);

    useEffect(() => {
        invalidate();
    }, [arePivotControlsActive]);

    return arePivotControlsActive && <PivotControlsHandler />;
};
